<script setup>
import { computed } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';

const props = defineProps({
  conversationId: { type: [Number, String], required: true },
  // A conversa foi apagada no OS e o runtime ainda a cita: o link abriria uma tela vazia.
  deleted: { type: Boolean, default: false },
});

const { accountScopedUrl } = useAccount();

const to = computed(() =>
  accountScopedUrl(`conversations/${props.conversationId}`)
);
</script>

<template>
  <span
    v-if="deleted"
    class="text-xs font-medium whitespace-nowrap text-n-slate-11"
  >
    {{ $t('ANALYTICS_REPORTS.DELETED_CONVERSATION') }}
  </span>
  <router-link
    v-else
    :to="to"
    class="text-xs font-medium whitespace-nowrap text-n-brand hover:underline"
  >
    {{ $t('ANALYTICS_REPORTS.OPEN_CONVERSATION', { id: conversationId }) }}
  </router-link>
</template>
